import React from "react";

import SchoolItemBase from "./SchoolItemBase";

const StudentSchoolItem = ({ itemId, onClose, isNewItem, gotoItem, DeleteItem, UpdateItem, InsertItem }) => {
  const config = {
    isStudentSchool: true,
  };

  return (
    <SchoolItemBase
      itemId={itemId}
      onClose={onClose}
      isNewItem={isNewItem}
      gotoItem={gotoItem}
      DeleteItem={DeleteItem}
      UpdateItem={UpdateItem}
      InsertItem={InsertItem}
      config={config}
    />
  );
};

export default StudentSchoolItem;
